/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisteredUser
 */
export interface RegisteredUser {
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    birthNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    birthDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    mpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    creationType: string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    createdDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    lastSignInDate?: string | null;
}

/**
 * Check if a given object implements the RegisteredUser interface.
 */
export function instanceOfRegisteredUser(value: object): value is RegisteredUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('creationType' in value) || value['creationType'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RegisteredUserFromJSON(json: any): RegisteredUser {
    return RegisteredUserFromJSONTyped(json, false);
}

export function RegisteredUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisteredUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'birthNumber': json['birthNumber'] == null ? undefined : json['birthNumber'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'mpk': json['mpk'] == null ? undefined : json['mpk'],
        'creationType': json['creationType'],
        'createdDateTime': json['createdDateTime'] == null ? undefined : json['createdDateTime'],
        'reason': json['reason'],
        'lastSignInDate': json['lastSignInDate'] == null ? undefined : json['lastSignInDate'],
    };
}

export function RegisteredUserToJSON(json: any): RegisteredUser {
    return RegisteredUserToJSONTyped(json, false);
}

export function RegisteredUserToJSONTyped(value?: RegisteredUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'email': value['email'],
        'phone': value['phone'],
        'birthNumber': value['birthNumber'],
        'birthDate': value['birthDate'],
        'mpk': value['mpk'],
        'creationType': value['creationType'],
        'createdDateTime': value['createdDateTime'],
        'reason': value['reason'],
        'lastSignInDate': value['lastSignInDate'],
    };
}

